import { defineMessages } from "../define";

/** The pizza list (table, cards, filters) and the orders pages (list and order detail). */
export default defineMessages({
  en: {
    // pizzas page
    "pizzas.page.allPizzas": "All pizzas",

    // pizza list: summary, day headers, empty state, pagination unit
    "pizzas.list.unit.one": "pizza",
    "pizzas.list.unit.few": "pizzas",
    "pizzas.list.unit.other": "pizzas",
    "pizzas.list.verdictUnit.one": "{verdict} pizza",
    "pizzas.list.verdictUnit.few": "{verdict} pizzas",
    "pizzas.list.verdictUnit.other": "{verdict} pizzas",
    "pizzas.list.shareTitle": "{ok} OK / {nok} NOK",
    "pizzas.list.unknownDay": "Unknown day",
    "pizzas.list.empty": "No pizzas match the filters.",

    // pizza list: toolbar
    "pizzas.toolbar.searchPlaceholder": "Search pizzas by name…",
    "pizzas.toolbar.searchLabel": "Search pizzas by name",
    "pizzas.toolbar.clearSearch": "Clear search",
    "pizzas.toolbar.filtersTitle": "Pizza filters",
    "pizzas.toolbar.filtersDescription": "Choose which pizzas the list shows.",

    // pizza list: column headers and the column visibility menu
    "pizzas.columns.photo": "Photo",
    "pizzas.columns.id": "ID",
    "pizzas.columns.pizzaId": "Pizza ID",
    "pizzas.columns.fullName": "Full name",
    "pizzas.columns.orderId": "Order ID",
    "pizzas.columns.capturedAt": "Captured at",
    "pizzas.columns.captures": "Captures",
    "pizzas.columns.checks": "Checks (icons)",
    "pizzas.columns.detection": "Detection",
    "pizzas.columns.components": "Components",
    "pizzas.columns.verdict": "Verdict",
    "pizzas.columns.ingredients": "Ingredients",
    "pizzas.columns.extras": "Extras",
    "pizzas.columns.removals": "Removals",
    "pizzas.columns.confidence": "Confidence",
    "pizzas.columns.componentCount": "Component count",
    "pizzas.columns.doneness": "Doneness",
    "pizzas.columns.pizzaSaver": "Pizza saver",
    "pizzas.columns.photoQuality": "Photo quality",
    "pizzas.columns.photoQualityShort": "Photo",

    // pizza list: cells
    "pizzas.cells.recapturedTitle": "Photo retaken",
    "pizzas.cells.capturedTimes": "{count}× captured",
    "pizzas.cells.burnt": "Burnt",
    "pizzas.cells.raw": "Raw",

    // pizza list: row actions menu
    "pizzas.actions.openMenu": "Open menu",
    "pizzas.actions.copyId": "Copy pizza ID",
    "pizzas.actions.copyData": "Copy pizza data",
    "pizzas.actions.pizzaData": "Pizza data",

    // pizza filters dialog
    "pizzas.filters.pizzaIds": "Pizza IDs",
    "pizzas.filters.pizzaIdsPlaceholder": "Enter pizza IDs…",
    "pizzas.filters.pizzaName": "Pizza name",
    "pizzas.filters.pizzaNamePlaceholder": "Enter a pizza name…",
    "pizzas.filters.orderIds": "Order IDs",
    "pizzas.filters.orderIdsPlaceholder": "Enter order IDs…",
    "pizzas.filters.captureDateRange": "Capture date range",
    "pizzas.filters.captureDate": "Capture date",
    "pizzas.filters.detection": "Pizza detection",
    "pizzas.filters.detectionPlaceholder": "Select the detection result",
    "pizzas.filters.confidenceRange": "Confidence (0–1)",
    "pizzas.filters.confidencePlaceholder": "Enter confidence…",
    "pizzas.filters.captureCount": "Capture count",
    "pizzas.filters.captureCountPlaceholder": "Enter capture count…",
    "pizzas.filters.componentCountPlaceholder": "Enter component count…",
    "pizzas.filters.donenessPlaceholder": "burnt, raw…",
    "pizzas.filters.verdictPlaceholder": "Select verdict",
    "pizzas.filters.ingredientsStatus": "Ingredients status",
    "pizzas.filters.ingredientsStatusPlaceholder": "Select ingredients status",
    "pizzas.filters.extrasStatus": "Extras status",
    "pizzas.filters.extrasStatusPlaceholder": "Select extras status",
    "pizzas.filters.removalsStatus": "Removals status",
    "pizzas.filters.removalsStatusPlaceholder": "Select removals status",
    "pizzas.filters.pizzaSaverStatus": "Pizza saver status",
    "pizzas.filters.pizzaSaverStatusPlaceholder": "Select pizza saver status",
    "pizzas.filters.photoQualityStatus": "Photo quality status",
    "pizzas.filters.photoQualityStatusPlaceholder": "Select photo quality status",
    "pizzas.filters.photoQualityCheck": "Photo quality check",
    "pizzas.filters.photoQualityCheckPlaceholder": "Select a failed check",
    "pizzas.filters.pizzaTypes": "Pizza types",
    "pizzas.filters.pizzaTypesPlaceholder": "Select pizza types",
    "pizzas.filters.pizzaTypesSearch": "Search pizza types…",
    "pizzas.filters.availablePizzaTypes": "Available pizza types",
    "pizzas.filters.componentError": "Component error",
    "pizzas.filters.componentErrorPlaceholder": "Missing or unwanted component…",
    "pizzas.filters.extrasAndRemovals": "Extras and removals",
    "pizzas.filters.hasExtras": "Has extras",
    "pizzas.filters.hasRemovals": "Has removals",
    "pizzas.filters.statusNone": "No status",
    "pizzas.filters.shadowMode": "{check} (shadow mode)",

    // active filter chips
    "pizzas.activeFilters.none": "No active filters",
    "pizzas.activeFilters.title": "Active filters",
    "pizzas.activeFilters.dateRange": "{from} – {to}",
    "pizzas.activeFilters.edit": "Click to edit the {filter} filter",
    "pizzas.activeFilters.clear": "Clear the {filter} filter",
    "pizzas.activeFilters.clearAll": "Clear all filters",

    // order list
    "orders.list.unit.one": "order",
    "orders.list.unit.few": "orders",
    "orders.list.unit.other": "orders",
    "orders.list.empty": "No orders match the filters.",
    "orders.toolbar.searchPlaceholder": "Order number or ID…",
    "orders.toolbar.searchLabel": "Filter orders by number or ID",
    "orders.toolbar.clearSearch": "Clear search",

    // order list: columns
    "orders.columns.orderNumber": "Order #",
    "orders.columns.sentAt": "Sent at",
    "orders.columns.items": "Items",
    "orders.columns.createdAt": "Created at",
    "orders.columns.orderId": "Order ID",
    "orders.columns.id": "ID",

    // order actions (list menu and detail menu)
    "orders.actions.openMenu": "Open menu",
    "orders.actions.menuLabel": "Order actions",
    "orders.actions.copyId": "Copy order ID",
    "orders.actions.copyData": "Copy order data",
    "orders.actions.orderData": "Order data",

    // order detail
    "orders.detail.label": "Order detail",
    "orders.detail.back": "Back to orders",
    "orders.detail.noSelection": "No order selected",
    "orders.detail.noSelectionHint": "Pick an order from the list to see its pizzas and their evaluation.",
    "orders.detail.loadFailed": "This order could not be loaded.",
    "orders.detail.nokCount": "{count} NOK",
    "orders.detail.ofTotal": "of {total}",
    "orders.detail.allOk.one": "{count} OK",
    "orders.detail.allOk.few": "all {count} OK",
    "orders.detail.allOk.other": "all {count} OK",
    "orders.detail.sent": "Sent {date}",
    "orders.detail.created": "Created {date}",
    "orders.detail.previousOrder": "Previous order",
    "orders.detail.nextOrder": "Next order",
    "orders.detail.pizzasHeading": "Pizzas ({count})",
    "orders.detail.noPizzas": "No pizzas in this order",
    "orders.detail.otherItems": "Other items ({count})",

    // order detail: pizza tiles and the pizza dots of the list
    "orders.tile.notCaptured": "Not captured",
    "orders.tile.noPhoto": "No photo of this pizza",
    "orders.tile.captured": "{date} · {count}× captured",
  },
  cs: {
    // pizzas page
    "pizzas.page.allPizzas": "Všechny pizzy",

    // pizza list: summary, day headers, empty state, pagination unit
    "pizzas.list.unit.one": "pizza",
    "pizzas.list.unit.few": "pizzy",
    "pizzas.list.unit.other": "pizz",
    "pizzas.list.verdictUnit.one": "{verdict} pizza",
    "pizzas.list.verdictUnit.few": "{verdict} pizzy",
    "pizzas.list.verdictUnit.other": "{verdict} pizz",
    "pizzas.list.shareTitle": "{ok} OK / {nok} NEOK",
    "pizzas.list.unknownDay": "Neznámý den",
    "pizzas.list.empty": "Filtrům neodpovídá žádná pizza.",

    // pizza list: toolbar
    "pizzas.toolbar.searchPlaceholder": "Hledat pizzu podle názvu…",
    "pizzas.toolbar.searchLabel": "Hledat pizzu podle názvu",
    "pizzas.toolbar.clearSearch": "Vymazat hledání",
    "pizzas.toolbar.filtersTitle": "Filtry pizz",
    "pizzas.toolbar.filtersDescription": "Vyberte, které pizzy se v seznamu zobrazí.",

    // pizza list: column headers and the column visibility menu
    "pizzas.columns.photo": "Fotka",
    "pizzas.columns.id": "ID",
    "pizzas.columns.pizzaId": "ID pizzy",
    "pizzas.columns.fullName": "Celý název",
    "pizzas.columns.orderId": "ID objednávky",
    "pizzas.columns.capturedAt": "Pořízeno",
    "pizzas.columns.captures": "Počet pořízení",
    "pizzas.columns.checks": "Kontroly (ikony)",
    "pizzas.columns.detection": "Detekce",
    "pizzas.columns.components": "Komponenty",
    "pizzas.columns.verdict": "Verdikt",
    "pizzas.columns.ingredients": "Suroviny",
    "pizzas.columns.extras": "Přídavky",
    "pizzas.columns.removals": "Odebrané suroviny",
    "pizzas.columns.confidence": "Jistota",
    "pizzas.columns.componentCount": "Počet komponent",
    "pizzas.columns.doneness": "Propečení",
    "pizzas.columns.pizzaSaver": "Pizza saver",
    "pizzas.columns.photoQuality": "Kvalita fotky",
    "pizzas.columns.photoQualityShort": "Fotka",

    // pizza list: cells
    "pizzas.cells.recapturedTitle": "Fotka byla pořízena znovu",
    "pizzas.cells.capturedTimes": "pořízeno {count}×",
    "pizzas.cells.burnt": "Spálená",
    "pizzas.cells.raw": "Nedopečená",

    // pizza list: row actions menu
    "pizzas.actions.openMenu": "Otevřít nabídku",
    "pizzas.actions.copyId": "Kopírovat ID pizzy",
    "pizzas.actions.copyData": "Kopírovat data pizzy",
    "pizzas.actions.pizzaData": "Data pizzy",

    // pizza filters dialog
    "pizzas.filters.pizzaIds": "ID pizz",
    "pizzas.filters.pizzaIdsPlaceholder": "Zadejte ID pizz…",
    "pizzas.filters.pizzaName": "Název pizzy",
    "pizzas.filters.pizzaNamePlaceholder": "Zadejte název pizzy…",
    "pizzas.filters.orderIds": "ID objednávek",
    "pizzas.filters.orderIdsPlaceholder": "Zadejte ID objednávek…",
    "pizzas.filters.captureDateRange": "Období pořízení",
    "pizzas.filters.captureDate": "Datum pořízení",
    "pizzas.filters.detection": "Detekce pizzy",
    "pizzas.filters.detectionPlaceholder": "Vyberte výsledek detekce",
    "pizzas.filters.confidenceRange": "Jistota (0–1)",
    "pizzas.filters.confidencePlaceholder": "Zadejte jistotu…",
    "pizzas.filters.captureCount": "Počet pořízení",
    "pizzas.filters.captureCountPlaceholder": "Zadejte počet pořízení…",
    "pizzas.filters.componentCountPlaceholder": "Zadejte počet komponent…",
    "pizzas.filters.donenessPlaceholder": "burnt (spálená), raw (nedopečená)…",
    "pizzas.filters.verdictPlaceholder": "Vyberte verdikt",
    "pizzas.filters.ingredientsStatus": "Stav surovin",
    "pizzas.filters.ingredientsStatusPlaceholder": "Vyberte stav surovin",
    "pizzas.filters.extrasStatus": "Stav přídavků",
    "pizzas.filters.extrasStatusPlaceholder": "Vyberte stav přídavků",
    "pizzas.filters.removalsStatus": "Stav odebraných surovin",
    "pizzas.filters.removalsStatusPlaceholder": "Vyberte stav odebraných surovin",
    "pizzas.filters.pizzaSaverStatus": "Stav pizza saveru",
    "pizzas.filters.pizzaSaverStatusPlaceholder": "Vyberte stav pizza saveru",
    "pizzas.filters.photoQualityStatus": "Stav kvality fotky",
    "pizzas.filters.photoQualityStatusPlaceholder": "Vyberte stav kvality fotky",
    "pizzas.filters.photoQualityCheck": "Kontrola kvality fotky",
    "pizzas.filters.photoQualityCheckPlaceholder": "Vyberte neúspěšnou kontrolu",
    "pizzas.filters.pizzaTypes": "Typy pizz",
    "pizzas.filters.pizzaTypesPlaceholder": "Vyberte typy pizz",
    "pizzas.filters.pizzaTypesSearch": "Hledat typ pizzy…",
    "pizzas.filters.availablePizzaTypes": "Dostupné typy pizz",
    "pizzas.filters.componentError": "Chyba komponenty",
    "pizzas.filters.componentErrorPlaceholder": "Chybějící nebo nežádoucí komponenta…",
    "pizzas.filters.extrasAndRemovals": "Přídavky a odebrané suroviny",
    "pizzas.filters.hasExtras": "Má přídavky",
    "pizzas.filters.hasRemovals": "Má odebrané suroviny",
    "pizzas.filters.statusNone": "Bez stavu",
    "pizzas.filters.shadowMode": "{check} (stínový režim)",

    // active filter chips
    "pizzas.activeFilters.none": "Žádné aktivní filtry",
    "pizzas.activeFilters.title": "Aktivní filtry",
    "pizzas.activeFilters.dateRange": "{from} – {to}",
    "pizzas.activeFilters.edit": "Kliknutím upravíte filtr „{filter}“",
    "pizzas.activeFilters.clear": "Zrušit filtr „{filter}“",
    "pizzas.activeFilters.clearAll": "Zrušit všechny filtry",

    // order list
    "orders.list.unit.one": "objednávka",
    "orders.list.unit.few": "objednávky",
    "orders.list.unit.other": "objednávek",
    "orders.list.empty": "Filtrům neodpovídá žádná objednávka.",
    "orders.toolbar.searchPlaceholder": "Číslo nebo ID objednávky…",
    "orders.toolbar.searchLabel": "Filtrovat objednávky podle čísla nebo ID",
    "orders.toolbar.clearSearch": "Vymazat hledání",

    // order list: columns
    "orders.columns.orderNumber": "Č. objednávky",
    "orders.columns.sentAt": "Odesláno",
    "orders.columns.items": "Položky",
    "orders.columns.createdAt": "Vytvořeno",
    "orders.columns.orderId": "ID objednávky",
    "orders.columns.id": "ID",

    // order actions (list menu and detail menu)
    "orders.actions.openMenu": "Otevřít nabídku",
    "orders.actions.menuLabel": "Akce s objednávkou",
    "orders.actions.copyId": "Kopírovat ID objednávky",
    "orders.actions.copyData": "Kopírovat data objednávky",
    "orders.actions.orderData": "Data objednávky",

    // order detail
    "orders.detail.label": "Detail objednávky",
    "orders.detail.back": "Zpět na objednávky",
    "orders.detail.noSelection": "Není vybraná žádná objednávka",
    "orders.detail.noSelectionHint": "Vyberte objednávku ze seznamu a uvidíte její pizzy a jejich vyhodnocení.",
    "orders.detail.loadFailed": "Objednávku se nepodařilo načíst.",
    "orders.detail.nokCount": "{count} NEOK",
    "orders.detail.ofTotal": "z {total}",
    "orders.detail.allOk.one": "{count} OK",
    "orders.detail.allOk.few": "všechny {count} OK",
    "orders.detail.allOk.other": "všech {count} OK",
    "orders.detail.sent": "Odesláno {date}",
    "orders.detail.created": "Vytvořeno {date}",
    "orders.detail.previousOrder": "Předchozí objednávka",
    "orders.detail.nextOrder": "Další objednávka",
    "orders.detail.pizzasHeading": "Pizzy ({count})",
    "orders.detail.noPizzas": "Objednávka neobsahuje žádnou pizzu",
    "orders.detail.otherItems": "Další položky ({count})",

    // order detail: pizza tiles and the pizza dots of the list
    "orders.tile.notCaptured": "Nepořízeno",
    "orders.tile.noPhoto": "K této pizze není fotka",
    "orders.tile.captured": "{date} · pořízeno {count}×",
  },
});
